import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Brand } from '@/components/Brand';
import { useAuth } from '@/context/AuthContext';
import { roleHome } from '@/lib/format';

export default function Register() {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [form, setForm] = useState({ name: '', email: '', telefone: '', password: '' });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) { toast.error('A senha deve ter ao menos 6 caracteres'); return; }
    setLoading(true);
    try {
      const u = await register(form);
      toast.success('Conta criada com sucesso!');
      navigate(roleHome(u.role), { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Não foi possível criar a conta');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img src="https://images.pexels.com/photos/33404422/pexels-photo-33404422.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1200" alt="Viagem" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-primary/40" />
        <div className="absolute bottom-10 left-10 right-10 text-primary-foreground">
          <h2 className="font-display text-3xl font-semibold">Crie sua conta de cliente</h2>
          <p className="mt-2 text-primary-foreground/90 max-w-sm">Acompanhe suas viagens, valores e assine contratos com praticidade.</p>
        </div>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-10 hero-wash">
        <div className="w-full max-w-sm">
          <Button asChild variant="ghost" size="sm" className="mb-4 -ml-2 text-muted-foreground" data-testid="register-back-to-site">
            <Link to="/"><ArrowLeft className="h-4 w-4 mr-2" /> Voltar ao site</Link>
          </Button>
          <Link to="/" className="flex items-center gap-2 mb-8">
            <Brand />
          </Link>
          <h1 className="font-display text-3xl font-semibold tracking-tight">Criar conta</h1>
          <p className="mt-2 text-sm text-muted-foreground">Para clientes acompanharem suas viagens.</p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <Label htmlFor="name">Nome completo</Label>
              <Input id="name" required value={form.name} onChange={set('name')} placeholder="Seu nome" className="mt-1.5" data-testid="register-name" />
            </div>
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={form.email} onChange={set('email')} placeholder="voce@email.com" className="mt-1.5" data-testid="register-email" />
            </div>
            <div>
              <Label htmlFor="telefone">Telefone</Label>
              <Input id="telefone" value={form.telefone} onChange={set('telefone')} placeholder="(11) 99999-9999" className="mt-1.5" data-testid="register-telefone" />
            </div>
            <div>
              <Label htmlFor="password">Senha</Label>
              <Input id="password" type="password" required value={form.password} onChange={set('password')} placeholder="Mínimo 6 caracteres" className="mt-1.5" data-testid="register-password" />
            </div>
            <Button type="submit" className="w-full" size="lg" disabled={loading} data-testid="register-submit">
              {loading ? 'Criando...' : 'Criar conta'}
            </Button>
          </form>

          <p className="mt-6 text-sm text-center text-muted-foreground">
            Já tem conta? <Link to="/login" className="text-primary font-medium hover:underline">Entrar</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
